var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMicoff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 43",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7676,
    y: 5.15234,
    width: 13.409,
    height: 23.4657,
    rx: 6.70448,
    fill: "#ACACAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7634 23.1674C12.6654 22.4801 12.112 21.9141 11.4178 21.9141C10.7235 21.9141 10.1533 22.4791 10.2295 23.1691C10.8084 28.4142 14.9726 32.579 20.2174 33.1588V37.4182H16.4461C15.7518 37.4182 15.189 37.981 15.189 38.6753C15.189 39.3695 15.7518 39.9323 16.4461 39.9323H26.5028C27.1971 39.9323 27.7599 39.3695 27.7599 38.6753C27.7599 37.981 27.1971 37.4182 26.5028 37.4182H22.7316V33.1588C27.9763 32.579 32.1406 28.4142 32.7195 23.1691C32.7956 22.4791 32.2255 21.9141 31.5312 21.9141C30.8369 21.9141 30.2835 22.4801 30.1855 23.1674C29.5772 27.4337 25.9089 30.7137 21.4745 30.7137C17.0401 30.7137 13.3718 27.4337 12.7634 23.1674Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8192 1.80078L1.35938 37.2606",
    stroke: "#EE6762",
    strokeWidth: 2.65949,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicoff);
export default __webpack_public_path__ + "static/media/icon_micoff.9cc636e6a7e6d1bf40c107f07d814f10.svg";
export { ForwardRef as ReactComponent };